import {
  ChangeDetectorRef,
  Component,
  Input,
  TemplateRef,
  ViewChild,
} from "@angular/core";

import { CommonModule, formatDate } from "@angular/common";
import { PaisService } from "src/app/core/services/pais.service";
import { EspecialistaAgendaService } from "src/app/core/services/especialista-agenda.service";
import {
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";

import { FlatpickrModule } from "angularx-flatpickr";

import { ServiciosService } from "src/app/core/services/servicios.service";
import { EspecialistaService } from "src/app/core/services/especialista.service";
import { Especialista } from "src/app/core/models/especialista.model";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { PaquetesAdquiridosService } from "src/app/core/services/paquetes-adquiridos.service";
import { NgSelectModule } from "@ng-select/ng-select";
import { ConfigService } from "src/app/core/services/config.service";
import Swal from "sweetalert2";
import { CitaService } from "src/app/core/services/cita.service";
import { Router } from "@angular/router";
import { CitasPagosService } from "src/app/core/services/citas-pagos.service";
import { TiposDocumentoService } from "src/app/core/services/tipos-documento.service";
import { ParentescoService } from "src/app/core/services/parentesco.service";
import { firstValueFrom } from "rxjs";
import { PacientesService } from "src/app/core/services/paciente.service";
import { UserService } from "src/app/core/services/user.service";
import { UsuariosRelaciones } from "src/app/core/models/usuarios-relaciones.model";
import { PaymentFormComponent } from "../../payment-form/payment-form.component";
import { environment } from "src/environments/environment";

// Traemos el html y scss y creamos el selector para usar el componente en citas-list-new
@Component({
  standalone: true,
  selector: "app-agenda-especialista",
  templateUrl: "./agenda-especialista.component.html",
  styleUrls: ["../../../app.component.scss", "./agenda-especialista.component.scss"],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    FlatpickrModule,
    PaymentFormComponent,
  ],
})
export class AgendaEspecialistaComponent {
  @Input() idEspecialista!: string;
  @Input() datosPaciente!: any;
  @ViewChild("confirmModal") confirmModal!: TemplateRef<any>;
  @ViewChild("createPaciente") createPaciente!: TemplateRef<any>;
  @ViewChild(PaymentFormComponent) paymentFormComponent: PaymentFormComponent;

  @ViewChild("estadoSelect") estadoSelect: any;
  @ViewChild("ciudadSelect") ciudadSelect: any;

  private modalReferences: { [key: string]: NgbModalRef } = {};

  // Variable usada para validar si los datos de paises, t documentos y ciudades y estados ya se cargaron antes
  private datosBasicosCargados = false;
  // Esta variable es usada cuando cambia el día seleccionado se guarde. Pero si se selecciona la hora no es necesario volver a cargar el id del horario
  horarioIdCargado = "";

  horarios: any[] = [];
  cargando = false;
  horariosVisible = false;
  fechaActual = new Date();
  diasMostrados: Date[] = [];
  diaSeleccionado: Date | null = null;

  // Formulario para agendar cita
  formData: FormGroup;

  // Datos del especialista
  datosEspecialista: any = [];
  serviciosEspecialista = [];
  servicios = [];

  // DATOS DEL PACIENTE
  paquetesPaciente = [];
  // Paquete elegido por el paciente en el modal de forma de pago
  paqueteSeleccionadoId: string | null = null;
  formDataPaciente: FormGroup;
  // datos del paciente a mostrar para que confirme que es el paciente correcto
  datosConfirmar = {
    nombresede: "",
    idSede: "",
    direccionSede: "",
    consultorio: "",
    fechaCita: "",
    startEvent: null,
    horaCita: "",
    paciente: "",
  };
  requiredContact: boolean = false;
  submittedPaciente: boolean = false;
  parentescos: any = [];
  tiposDocumento: any = [];
  paises: any = [];
  departamentos: any = [];
  ciudades: any = [];

  idUsuarioAsigna: string;
  tUsuarioAsigna: string;
  nombreUsuarioAsigna: string;
  servicioSeleccionado = null;
  nombresede: string = "";
  direccionSede: string = "";
  consultorio: string = "";
  fechaCita: string = "";
  valorTotal: number = 0;
  valorServicio: number = 0;
  descuento: number = 0;
  idServiciosEspecialista = [];
  submitted: boolean;
  duracion: number = 0;
  telefono_soporte: string;

  //Datos para la agenda
  @Input() convenios: any[] = [];

  constructor(
    private fb: FormBuilder,
    private __paisService: PaisService,
    private __especialistaAgendaService: EspecialistaAgendaService,
    private __especialistasService: EspecialistaService,
    private __serviciosService: ServiciosService,
    private modalService: NgbModal,
    private __paquetesAdquiridosService: PaquetesAdquiridosService,
    private configService: ConfigService,
    private __citasservice: CitaService,
    private router: Router,
    private __citasPagosService: CitasPagosService,

    private __tiposDocumentoService: TiposDocumentoService,
    private __parentescoService: ParentescoService,
    private __pacientesService: PacientesService,
    private __userService: UserService,
    private cdr: ChangeDetectorRef,
  ) {
    this.formData = this.fb.group({
      modalidad: ["Presencial", Validators.required],
      servicio: ["", Validators.required],
      duracion: ["", Validators.required],
      convenio: ["SI"],
      detalle: [""],
    });
    // FORMULARIO DEL PACIENTE
    this.formDataPaciente = this.fb.group({
      nombres: ["", Validators.required],
      apellidos: ["", Validators.required],
      tDocumento: [null, Validators.required],
      identificacion: ["", Validators.required],
      celular: [, Validators.required],
      email: ["", [Validators.required, Validators.email]],
      fnacimiento: ["", Validators.required],

      contactoNombre: [""],
      contactoParentesco: [""],
      contactoTelefono: [""],

      idPaisResidencia: ["CO", Validators.required],
      idEstadoResidencia: [null, Validators.required], //DEPARTAMENTO
      idCiudadResidencia: [null, Validators.required],
    });
  }

  ngOnInit() {
    // YA NO necesitamos obtener datos de sesión aquí porque vienen como @Input()
    // Los datosPaciente se reciben desde CitasListNewComponent

    //console.log('Datos del paciente recibidos como Input:', this.datosPaciente);

    /* Si necesitas hacer algo específico cuando recibes datos del paciente
    if (this.datosPaciente) {
      console.log('Paciente disponible en agenda:', this.datosPaciente);
    }*/

    // Función para listar todos los días de la semana
    this.generarDiasMostrados();
    this.diaSeleccionado = this.diasMostrados[0];
  }

  async agendarCita(horario: any) {
    // // Resetear valores - Aplicar convenio en SI por defecto
    if (this.datosPaciente?.idConvenio) {
      if (
        this.datosPaciente.idConvenio.requiereAprobacion &&
        this.datosPaciente.role === "PACIENTE"
      ) {
        this.selectNoConvenio();
        this.descuento = 0;
      } else {
        this.formData.patchValue({ convenio: "SI" });
        this.descuento = this.datosPaciente.idConvenio.descuento;
      }
    } else {
      this.selectNoConvenio();
      this.descuento = 0;
    }

    // Horarios
    // console.log('horarios', this.horarios);

    // console.log('Horario seleccionado:', horario);
    // console.log('this.idEspecialista:', this.idEspecialista);
    // Trae agenda del especialista
    //console.log('horario.id', horario.id);
    //console.log('horarioIdCargado', this.horarioIdCargado);

    // Siempre actualizar la hora seleccionada para que el popup refleje la última selección
    const horaSolo = horario.hora.substring(0, 5);
    this.datosConfirmar.horaCita = horaSolo;

    // Si el día seleccionado está disponible, recalcular fechaCita con la nueva hora
    if (this.diaSeleccionado) {
      const fechaSolo = this.diaSeleccionado.toISOString().split("T")[0];
      const fechaHora = `${fechaSolo}T${horaSolo}:00`;
      this.datosConfirmar.fechaCita = formatDate(
        fechaHora,
        "d-MMM-yyyy HH:mm",
        "en-US",
      );
      this.datosConfirmar.startEvent = new Date(this.diaSeleccionado);
    }

    // Esta validación evita volver a cargar sede/consultorio si es el mismo documento de agenda
    if (horario.id != this.horarioIdCargado) {
      this.horarioIdCargado = horario.id;
      this.__especialistaAgendaService
        .getDocument(horario.id)
        .then((res: any) => {
          // Verifica si res es undefined o no tiene la propiedad fecha
          if (!res || !res.fecha) {
            console.error("No se pudo obtener la fecha del documento");
            return;
          }
          this.datosConfirmar.nombresede = res.idSedeConsultorio.idSede.sede;
          this.datosConfirmar.idSede = res.idSedeConsultorio.idSede.$id;
          this.datosConfirmar.direccionSede =
            res.idSedeConsultorio.idSede.direccion;
          this.datosConfirmar.consultorio = res.idSedeConsultorio.descripcion;

          // CHECKEAR SI ES ONLINE O NO.
          const modalidadInicial =
            this.datosConfirmar.idSede === "online" ? "Online" : "Presencial";
          this.formData.patchValue({
            modalidad: modalidadInicial,
          });
          this.getServiciosByModalidad();
        })
        .catch((error) => {
          console.error("Error al obtener el documento:", error);
        });
    }

    // Validar si hay paciente o es paciente nuevo
    if (this.datosPaciente) {
      this.getServiciosByModalidad();
      this.datosConfirmar.paciente = this.datosPaciente.nombre;
      this.modalService.open(this.confirmModal, { centered: true });
      this.consultarPaquetesPaciente(this.datosPaciente.$id);
    } else {
      // Abre modal para insertar el paciente con el formulario
      const modalRef = this.modalService.open(this.createPaciente, {
        centered: true,
      });
      this.modalReferences["createPaciente"] = modalRef;

      // NO EXISTE EL PACIENTE O ES UN PACIENTE NUEVO
      // DATOS PARA EL FORMULARIO DE CREACIÓN DE PACIENTE NUEVO
      if (!this.datosBasicosCargados) {
        this.getTiposDocumento((data: { documents: any[] }) => {
          this.tiposDocumento = data.documents;
        });
        this.getParentesco((data) => {
          this.parentescos = data;
        });
        await this.getPaises();
        // await this.getCiudades(null);
        await this.getStatesCountries(null);
        this.datosBasicosCargados = true;
      }
    }
  }

  // #########################################################
  // Confirmar cita
  // Se valida la hora seleccionada este disponible y dentro del rango
  // #########################################################

  async confirmarCita() {
    this.submitted = true;
    if (this.formData.invalid) {
      return;
    } else {
      // Refrescar horarios desde la API para evitar datos obsoletos
      await this.cargarHorarios();

      // Verificar que el horario seleccionado sigue disponible
      const horaDisponible = this.horarios.some(
        (horario) => horario.hora === this.datosConfirmar.horaCita,
      );
      if (!horaDisponible) {
        Swal.fire({
          icon: "error",
          title: "Horario no disponible",
          text: "Este horario ya no está disponible. Por favor selecciona otro horario.",
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }

      if (this.formData.value.duracion == "60") {
        const horaSeleccionada = this.datosConfirmar.horaCita;
        // console.log('Hora seleccionada:', horaSeleccionada);
        const [horas, minutos] = horaSeleccionada.split(":");
        const horaInicio = new Date();
        horaInicio.setHours(parseInt(horas), parseInt(minutos), 0, 0);

        const horaSiguiente = new Date(horaInicio.getTime() + 30 * 60 * 1000);
        const horaSiguienteStr =
          horaSiguiente.getHours().toString().padStart(2, "0") +
          ":" +
          horaSiguiente.getMinutes().toString().padStart(2, "0");

        const validacionHorarioSiguiente = this.horarios.some(
          (horario) => horario.hora === horaSiguienteStr,
        );

        if (!validacionHorarioSiguiente) {
          Swal.fire({
            icon: "error",
            title: "El horario seleccionado no está disponible para una hora",
            showConfirmButton: false,
            timer: 2500,
          });
          return;
        }
      }
      this.confirmarResumenCita();
    }
  }

  // Resumen de la cita antes de solicitarla, para que el paciente confirme
  // los datos. Al aceptar se continúa con la forma de pago.
  async confirmarResumenCita() {
    const paquetesAplicables = this.paquetesPaciente.filter(
      (paquete) => this.clasificarPaquete(paquete).aplica,
    );

    const fila = (etiqueta: string, valor: any) => `
      <div style="display:flex;justify-content:space-between;gap:1rem;padding:.3rem 0;border-bottom:1px solid #f1f2f4">
        <span style="color:#74788d">${etiqueta}</span>
        <strong style="text-align:right">${valor || "-"}</strong>
      </div>`;

    let html = `<div style="text-align:left">`;
    html += fila("Paciente", this.datosConfirmar.paciente);
    html += fila("Especialista", this.datosEspecialista?.nombre);
    html += fila("Fecha y hora", this.datosConfirmar.fechaCita);
    html += fila("Modalidad", this.formData.value.modalidad);
    html += fila("Servicio", this.servicioSeleccionado?.servicio);
    html += fila("Duración", `${this.formData.value.duracion} minutos`);
    html += fila(
      "Sede",
      this.datosConfirmar.idSede === "online"
        ? "Online"
        : `${this.datosConfirmar.nombresede} · Consultorio ${this.datosConfirmar.consultorio}`,
    );

    html += fila("Total", `$${this.valorTotal}`);
    html += fila(
      "Forma de pago",
      paquetesAplicables.length > 0
        ? "Paquete o pago, la eliges en el siguiente paso"
        : "La eliges en el siguiente paso",
    );

    if (this.formData.value.detalle) {
      html += fila("Motivo de consulta", this.formData.value.detalle);
    }

    html += `</div>`;

    const confirmacion = await Swal.fire({
      title: "Confirma los datos de tu cita",
      html,
      showCancelButton: true,
      confirmButtonColor: "#2ab57d",
      confirmButtonText: "Confirmar y continuar",
      cancelButtonText: "Volver",
    });

    if (confirmacion.isConfirmed) {
      this.validaSiTienePaquete();
    }
  }

  // Devuelve el $id de una relación de Appwrite (o el valor si viene como texto)
  idRelacion(valor: any): string {
    return (valor?.$id ?? valor ?? "").toString();
  }

  // Determina si un paquete aplica a la cita que se está agendando.
  // Deben coincidir modalidad, tipo de consulta (control / primera vez),
  // tipo de terapia (psicología / neuropsicología) y a quién va dirigido
  // (adulto / niñez), además de quedarle citas disponibles.
  clasificarPaquete(paquete: any) {
    const servicioPaquete = paquete?.idServicio;

    const modalidadCita = (this.formData.value.modalidad || "")
      .toString()
      .trim()
      .toLowerCase();
    const modalidadPaquete = (servicioPaquete?.modalidad || "")
      .toString()
      .trim()
      .toLowerCase();

    const coincideModalidad =
      !!modalidadCita && modalidadCita === modalidadPaquete;

    const tipoConsultaCita = this.idRelacion(
      this.servicioSeleccionado?.tConsulta,
    );
    const coincideTipoConsulta =
      !!tipoConsultaCita &&
      tipoConsultaCita === this.idRelacion(servicioPaquete?.tConsulta);

    const tipoTerapiaCita = this.idRelacion(this.servicioSeleccionado?.tTerapia);
    const coincideTerapia =
      !!tipoTerapiaCita &&
      tipoTerapiaCita === this.idRelacion(servicioPaquete?.tTerapia);

    const dirigidoCita = this.idRelacion(this.servicioSeleccionado?.tDirigido);
    const coincideDirigido =
      !!dirigidoCita &&
      dirigidoCita === this.idRelacion(servicioPaquete?.tDirigido);

    // La duración de la cita debe estar cubierta por la del paquete:
    // un paquete de 30 min no puede pagar una cita de 60.
    const duracionCita = Number(this.formData.value.duracion);
    const duracionPaquete = Number(servicioPaquete?.duracion);
    const coincideDuracion =
      !!duracionCita && !!duracionPaquete && duracionCita === duracionPaquete;

    const tieneCitas = paquete?.citasRestantes > 0;

    // Traza para validar el cruce paquete <-> cita
    console.log("clasificarPaquete", {
      paquete: servicioPaquete?.servicio,
      cita: this.servicioSeleccionado?.servicio,
      modalidad: [modalidadPaquete, modalidadCita, coincideModalidad],
      tConsulta: [
        this.idRelacion(servicioPaquete?.tConsulta),
        tipoConsultaCita,
        coincideTipoConsulta,
      ],
      tTerapia: [
        this.idRelacion(servicioPaquete?.tTerapia),
        tipoTerapiaCita,
        coincideTerapia,
      ],
      tDirigido: [
        this.idRelacion(servicioPaquete?.tDirigido),
        dirigidoCita,
        coincideDirigido,
      ],
      duracion: [duracionPaquete, duracionCita, coincideDuracion],
      citasRestantes: paquete?.citasRestantes,
    });

    const motivos = [];
    if (!coincideModalidad) {
      motivos.push(
        `Modalidad ${servicioPaquete?.modalidad || "sin definir"} (tu cita es ${this.formData.value.modalidad})`,
      );
    }
    if (!coincideDirigido) {
      motivos.push(
        `Dirigido a ${servicioPaquete?.tDirigido?.dirigido || "otro público"} (tu cita es ${
          this.servicioSeleccionado?.tDirigido?.dirigido || "otra"
        })`,
      );
    }
    if (!coincideTerapia) {
      motivos.push(
        `Terapia ${servicioPaquete?.tTerapia?.terapia || "distinta"} (tu cita es ${
          this.servicioSeleccionado?.tTerapia?.terapia || "otra"
        })`,
      );
    }
    if (!coincideTipoConsulta) {
      motivos.push("Otro tipo de consulta (control / primera vez)");
    }
    if (!coincideDuracion) {
      motivos.push(
        `Sesiones de ${duracionPaquete || "?"} min (tu cita es de ${duracionCita} min)`,
      );
    }
    if (!tieneCitas) {
      motivos.push("Sin citas disponibles");
    }

    return {
      aplica:
        coincideModalidad &&
        coincideTipoConsulta &&
        coincideTerapia &&
        coincideDirigido &&
        coincideDuracion &&
        tieneCitas,
      motivos,
    };
  }

  // Construye el listado de paquetes del paciente para el modal de forma de pago.
  // Se muestran TODOS los paquetes: los que aplican a la modalidad y tipo de
  // consulta seleccionados quedan resaltados y seleccionables; el resto se
  // muestra atenuado, indicando por qué no aplica.
  construirHtmlPaquetes(paquetes: any[]): string {
    const nombrePaquete = (paquete: any) =>
      paquete?.idServicio?.servicio || "Paquete";
    const detallePaquete = (paquete: any) => {
      const detalles = [];
      if (paquete?.idServicio?.tTerapia?.terapia) {
        detalles.push(paquete.idServicio.tTerapia.terapia);
      }
      if (paquete?.idServicio?.modalidad) {
        detalles.push(paquete.idServicio.modalidad);
      }
      if (paquete?.idServicio?.duracion) {
        detalles.push(`${paquete.idServicio.duracion} min`);
      }
      return detalles.join(" · ");
    };

    // Los que aplican primero, para que queden a la vista
    const clasificados = paquetes
      .map((paquete) => ({ paquete, ...this.clasificarPaquete(paquete) }))
      .sort((a, b) => Number(b.aplica) - Number(a.aplica));

    let html = `<div style="text-align:left">`;
    html += `<p style="margin-bottom:.5rem">Cita seleccionada: <strong>${
      this.servicioSeleccionado?.servicio || "-"
    }</strong> · <strong>${this.formData.value.modalidad}</strong></p>`;
    html += `<p style="margin-bottom:.75rem;color:#74788d"><small>Estos son tus paquetes. Los resaltados aplican a esta cita; selecciona de cuál quieres descontarla, o elige 'Prefiero pagar esta cita' para no gastar tu paquete.</small></p>`;

    let primeroAplicable = true;
    clasificados.forEach(({ paquete, aplica, motivos }) => {
      const detalle = detallePaquete(paquete);

      if (aplica) {
        const checked = primeroAplicable ? "checked" : "";
        primeroAplicable = false;
        html += `
          <label style="display:block;border:2px solid #2ab57d;background:#f1fbf7;border-radius:6px;padding:.6rem .75rem;margin-bottom:.5rem;cursor:pointer">
            <input type="radio" name="paqueteSeleccionado" value="${paquete.$id}" ${checked} style="margin-right:.5rem">
            <strong>${nombrePaquete(paquete)}</strong>
            <span style="background:#2ab57d;color:#fff;border-radius:4px;padding:0 .35rem;font-size:11px;margin-left:.35rem">Aplica</span><br>
            <small style="color:#74788d">${
              detalle ? detalle + " · " : ""
            }Citas restantes: <strong>${paquete.citasRestantes}</strong></small>
          </label>`;
      } else {
        html += `
          <div style="border:1px dashed #dfe3e8;border-radius:6px;padding:.5rem .75rem;margin-bottom:.4rem;opacity:.6">
            <strong>${nombrePaquete(paquete)}</strong><br>
            <small style="color:#74788d">${
              detalle ? detalle + " · " : ""
            }Citas restantes: <strong>${paquete.citasRestantes}</strong></small><br>
            <small style="color:#f1734f">No aplica: ${motivos.join(" · ")}</small>
          </div>`;
      }
    });

    html += `</div>`;
    return html;
  }

  // Validación si el paciente tiene paquetes
  async validaSiTienePaquete() {
    this.paqueteSeleccionadoId = null;

    if (this.paquetesPaciente.length > 0) {
      const aplicables = this.paquetesPaciente.filter(
        (paquete) => this.clasificarPaquete(paquete).aplica,
      );

      if (aplicables.length > 0) {
        return Swal.fire({
          title: "Forma de pago de tu cita ",
          html: this.construirHtmlPaquetes(this.paquetesPaciente),
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonColor: "#2ab57d",
          confirmButtonText: "Descontar del paquete",
          denyButtonText: "Prefiero pagar esta cita",
          denyButtonColor: "#4F95BE",
          cancelButtonText: `Cancelar`,
          preConfirm: () => {
            const seleccionado = document.querySelector(
              'input[name="paqueteSeleccionado"]:checked',
            ) as HTMLInputElement;
            if (!seleccionado) {
              Swal.showValidationMessage(
                "Selecciona el paquete del que se descontará la cita",
              );
              return false;
            }
            return seleccionado.value;
          },
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.paqueteSeleccionadoId = result.value;
            this.createCitaValidada("PAQUETE");
          } else if (result.isDenied) {
            // El paciente tiene paquete pero prefiere no gastarlo en esta cita
            this.preguntarFormaPago();
          }
        });
      }
    }

    // Sin paquete aplicable: el paciente elige cómo pagar
    return this.preguntarFormaPago();
  }

  // Modal de pago en línea / en consultorio
  preguntarFormaPago() {
    return Swal.fire({
      title: "Forma de pago de tu cita ",
      html: `
            Total a pagar: <strong>$${this.valorTotal}</strong><br><br>
            Paga en línea tu consulta, vía PSE, Tarjetas Débito, Crédito, Nequi. <br> Puedes pagar en el momento de confirmar la cita.
        `,
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonColor: "#2ab57d",
      confirmButtonText: "Pago en línea",
      denyButtonText: `En consultorio`,
      denyButtonColor: "#4F95BE",
      cancelButtonText: `Cancelar`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.createCitaValidada("ONLINE");
      } else if (result.isDenied) {
        this.createCitaValidada("CONSULTORIO");
      }
    });
  }

  // SE CREA LA CITA
  async createCitaValidada(modoPago) {
    let validoPaquete = false,
      citasRestantes = 0;
    let paqueteEncontrado: any = null;
    try {
      // Identificar el paquete (sin descontarlo todavía)
      if (this.paquetesPaciente.length > 0 && modoPago == "PAQUETE") {
        // Se usa el paquete que el paciente eligió en el modal
        paqueteEncontrado = this.paquetesPaciente.find(
          (paquete) => paquete.$id === this.paqueteSeleccionadoId,
        );
        if (paqueteEncontrado) {
          citasRestantes = paqueteEncontrado.citasRestantes - 1;
          validoPaquete = true;
        }
      }

      const cita: any = {
        detalle: this.formData.value.detalle,
        VrServicio: this.valorServicio,
        VrDescuento: parseInt(this.descuento.toString(), 10),
        VrTotal: this.valorTotal,
        idEstadoCita: "agendada",
        fechaCita: this.datosConfirmar.fechaCita,
        idSede: this.datosConfirmar.idSede,
        modalidad: this.formData.value.modalidad,
        servicioId: this.formData.value.servicio,
        IdEstadoPago: validoPaquete ? "paquete" : "creada",
        // Se guarda de qué paquete se descontó, para poder devolver la sesión
        // exactamente a ese paquete si la cita se cancela o se reprograma.
        idPaqueteAdquirido: validoPaquete ? paqueteEncontrado.$id : null,
        idPaciente: this.datosPaciente.$id,
        duracionCita: this.formData.value.duracion.toString(),
        idEspecialista: this.datosEspecialista.$id,
        tUsuarioAsigna: this.tUsuarioAsigna,
        idUsuarioAsigna: this.idUsuarioAsigna,
        consultorio: this.datosConfirmar.consultorio,
        nombreUsuarioAsigna: this.nombreUsuarioAsigna,
        convenio: this.formData.value.convenio === "SI" ? true : false,
        idConvenio:
          this.formData.value.convenio === "SI"
            ? this.datosPaciente.idConvenio.$id
            : null,
      };

      // FIX: Verificar que el horario no fue tomado por otro paciente antes de crear
      const citasExistentes = await this.__citasservice.getCitasAndValidate(
        this.datosEspecialista.$id,
        this.datosConfirmar.fechaCita,
      );
      if (citasExistentes.length > 0) {
        Swal.fire({
          icon: "error",
          title: "Horario no disponible",
          text: "Este horario acaba de ser reservado por otro paciente. Por favor selecciona otro horario.",
          showConfirmButton: false,
          timer: 3500,
        });
        await this.cargarHorarios();
        return;
      }

      console.log("Data being sent to createDocument (cita):", cita);
      const createCita = await this.__citasservice.createDocument(cita);
      console.log("Response from createDocument (cita):", createCita);

      // FIX: Descontar el paquete DESPUÉS de crear la cita exitosamente
      if (validoPaquete && paqueteEncontrado) {
        const restarPaquete =
          await this.__paquetesAdquiridosService.updateDocument(
            paqueteEncontrado.$id,
            { citasRestantes: citasRestantes },
          );
        console.log("Response from updateDocument (paquete):", restarPaquete);
      }

      if (validoPaquete) {
        Swal.fire({
          icon: "success",
          title: "Se ha asignado la cita",
          text:
            "Se ha descontado una cita de su paquete, le quedan " +
            citasRestantes +
            " citas",
          showConfirmButton: false,
          timer: 3500,
        });
        this.modalService.dismissAll();
        this.router.navigateByUrl("/#misCitas").then(() => {
          // Forzar recarga completa de la página
          window.location.reload();
        });
      } else {
        await this.pasarelaPago(createCita.$id, this.valorTotal, modoPago);

        if (modoPago === "ONLINE") {
          await Swal.fire({
            icon: "success",
            title: "Tu cita se ha agendado!",
            text: "En este momento vas a ser redireccionado a la pasarela de pagos.",
            showConfirmButton: false,
            timer: 3000,
          });
          // La pasarela redirige por sí sola: no se recarga la página para no
          // interrumpir el envío del formulario de pago.
          this.modalService.dismissAll();
          return;
        }

        await Swal.fire({
          icon: "success",
          title: "Tu cita se ha agendado!",
          text: "Tu pago será recibido en consultorio o desde tu panel de control.",
          showConfirmButton: false,
          timer: 3000,
        });
        this.modalService.dismissAll();
        this.router.navigateByUrl("/#misCitas").then(() => {
          // Forzar recarga completa de la página
          window.location.reload();
        });
      }
    } catch (error) {
      console.log("error generando cita:", error);
    }
  }

  // FUNCION PARA OBTENER LA HORA ACTUAL DEL SISTEMA
  getCurrentTime(): number {
    let newDate = new Date(this.fechaActual.getTime());
    newDate.setHours(newDate.getHours() + 5);
    return newDate.getHours();
  }

  // #########################################################

  changeModalidad(event) {
    this.valorTotal = 0;
    this.getServiciosByModalidad();
  }

  // #########################################################
  changeServicio(event) {
    this.servicioSeleccionado = event;
    //console.log('SERVICIO SELECCIONADO::', event);

    this.valorServicio = 0;

    if (event != undefined) {
      if (event.duracion) {
        this.formData.get("duracion").setValue(event.duracion);
        this.duracion = event.duracion;
      } else {
        this.formData.get("duracion").setValue(30);
        this.duracion = 30;
      }

      //console.log('País del paciente:', this.datosPaciente.pais);

      if (this.datosPaciente.pais == "CO") {
        this.valorServicio = event.valorCop;
        //console.log('Valor en COP seleccionado:', event.valorCop);
        //console.log('Valor servicio asignado (COP):', this.valorServicio);
      } else {
        this.valorServicio = event.valorUsd;
        //console.log('Valor en USD seleccionado:', event.valorUsd);
        //console.log('Valor servicio asignado (USD):', this.valorServicio);
      }
    }

    this.calcularValorTotal();
  }

  calcularValorTotal() {
    //console.log('=== CÁLCULO VALOR TOTAL ===');
    //console.log('Valor servicio antes del descuento:', this.valorServicio);
    //console.log('Descuento aplicado (%):', this.descuento);
    //console.log('Valor del descuento:', (this.valorServicio * this.descuento) / 100);

    this.valorTotal =
      this.valorServicio - (this.valorServicio * this.descuento) / 100;

    //console.log('Valor total calculado:', this.valorTotal);
    //console.log('========================');
  }

  // #########################################################
  // Formulario de paciente cita
  // #########################################################

  // cuando se cambia el radio select de si o no
  async selectConvenio(event) {
    if (event.target.value == "SI") {
      if (
        this.datosPaciente.idConvenio.requiereAprobacion &&
        this.datosPaciente.role === "PACIENTE"
      ) {
        this.configService
          .getConfigValue("EMPRESA", "TELEFONO_SOPORTE")
          .subscribe((dato) => {
            this.telefono_soporte = dato;
          });

        Swal.fire({
          icon: "error",
          title: `Por favor, comuníquese con el Contact Center al teléfono ${this.telefono_soporte}`,
          showConfirmButton: true,
        });
        this.selectNoConvenio();
      } else {
        this.descuento = this.datosPaciente.idConvenio.descuento;
      }
    } else {
      this.descuento = 0;
    }

    this.calcularValorTotal();
  }

  // Se utiliza la pasarela de pagos
  async pasarelaPago(idCita, valor, modoPago) {
    const currentDate = new Date().toLocaleString("en-US", {
      timeZone: "America/Bogota",
    });

    const dataCitaPago = {
      idCita: idCita,
      IdEstadoPago: "creada",
      referencia: "c_" + idCita,
      fechaPago: currentDate,
      valor: valor,
      descripcion: "Compra Cita",
    };
    const createCitaPago = await this.__citasPagosService.createDocument(
      dataCitaPago,
    );
    // console.log('createCitaPago::', createCitaPago);

    // Solo el pago en línea abre la pasarela; en consultorio queda pendiente
    // y el paciente puede pagarlo luego desde Mis Citas.
    if (modoPago === "ONLINE" && this.paymentFormComponent) {
      this.paymentFormComponent.signature = await this.generateHash(
        "c_" + idCita,
      );
      this.paymentFormComponent.amountInCents = this.valorTotal;
      this.paymentFormComponent.reference = "c_" + idCita;
      this.paymentFormComponent.submitPayment();
    }
  }

  // Firma de integridad exigida por Wompi
  async generateHash(idPago: string) {
    const valor = this.valorTotal;
    const cadenaConcatenada =
      idPago + valor * 100 + "COP" + environment.wompi.testIntegrity;

    const encondedText = new TextEncoder().encode(cadenaConcatenada);
    const hashBuffer = await crypto.subtle.digest("SHA-256", encondedText);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
  }

  get form() {
    return this.formData.controls;
  }

  // #########################################################
  // Función de paises
  // #########################################################
  async getStatesCountries(event): Promise<void> {
    const valorSeleccionado = event ? event.iso2 : "CO";
    this.departamentos = await firstValueFrom(
      this.__paisService.getStatesCountries(valorSeleccionado),
    );
  }
  async getPaises(): Promise<void> {
    this.paises = await firstValueFrom(this.__paisService.getCountries());
  }

  // DATOS PARA LOS PACIENTES NUEVOS.
  getTiposDocumento(dataComp) {
    this.__tiposDocumentoService.getTiposDocumento().then((data) => {
      dataComp(data);
    });
  }

  getParentesco(dataComp) {
    this.__parentescoService.getData().then((data) => {
      dataComp(data);
    });
  }

  selectNoConvenio() {
    this.formData.patchValue({
      convenio: "NO",
    });
    // console.log(
    //   'DATA CONVENIO CUANDO CAMBIA SELECTNOCONVENIO: ',
    //   this.formData.value.convenio
    // );
  }

  // #################################
  // Listado de los servicios por modalidad son los servicios a listarse para ofrecerle al paciente
  getServiciosByModalidad() {
    // console.log('getServiciosByModalidad');
    // Ids de los servicios
    const dataArray = this.dataServiceArray();
    // console.log('cdataArray::', dataArray);
    this.formData.get("servicio").reset();
    this.servicios = [];
    this.__serviciosService
      .getDocumentsByModalidadIncludeArray(
        this.formData.value.modalidad,
        dataArray,
      )
      .then((data) => {
        // Rafael
        // Filtra que los servicios sean para el especialista
        this.servicios = data.filter((servicio) => {
          const isColombian = this.datosPaciente?.idPaisResidencia === "CO";
          // console.log('isColombian::', isColombian);
          const isCopValid = servicio.valorCop > 0;
          const isUsdValid = servicio.valorUsd > 0;
          return (isColombian && isCopValid) || (!isColombian && isUsdValid);
        });
        // console.log('DATA SERVICIOS:', this.servicios);
      });
  }

  // Función para obtener solo los ids de los servicios que presta el especialista
  // Toma solo los ids y devuelve un array para luego filtrar en los servicios a mostrar
  dataServiceArray() {
    return this.serviciosEspecialista.map((dato) => dato.servicioId.$id);
  }

  // Traer toda la información del especialista
  // Esta función de llama únicamente cuando se da click en  mostrarHorarios()
  getEspecialista() {
    this.__especialistasService
      .getEspecialistaOneCompleteNew(this.idEspecialista)
      .then((response) => {
        this.datosEspecialista = response;
        // console.log('this.datosEspecialista', this.datosEspecialista);
        // Trae los servicios que presta el especialista

        // Verificar que servicios existe y es un array
        if (
          this.datosEspecialista.servicios &&
          Array.isArray(this.datosEspecialista.servicios)
        ) {
          this.serviciosEspecialista = this.datosEspecialista.servicios.filter(
            (servicio) => {
              servicio.fDesde = new Date(servicio.fDesde).toUTCString();
              servicio.fHasta = new Date(servicio.fHasta).toUTCString();

              if (
                servicio.fDesde <= this.fechaActual.toUTCString() &&
                this.fechaActual.toUTCString() <= servicio.Fhasta
              ) {
                console.log(" 2", servicio);
              }
              return servicio;
            },
          );
        } else {
          console.log("servicios no existe o no es un array");
          this.serviciosEspecialista = [];
        }
      });
  }

  async consultarPaquetesPaciente(idPaciente: string) {
    // Validar que el ID del paciente existe
    if (!idPaciente || idPaciente === "undefined") {
      console.warn("No se proporcionó ID de paciente para consultar paquetes");
      this.paquetesPaciente = [];
      return;
    }

    try {
      const paquetesPaciente =
        await this.__paquetesAdquiridosService.getDataByPaciente(idPaciente);
      this.paquetesPaciente = paquetesPaciente;
      //console.log('PAQUETES PACIENTE::', paquetesPaciente);
    } catch (error) {
      console.error("Error al consultar paquetes del paciente:", error);
      this.paquetesPaciente = [];
    }
  }

  // FUNCIÓN PARA MOSTRAR HORARIOS DESPUES DE DAR CLICK EN ELBOTON
  mostrarHorarios() {
    if (!this.horariosVisible) {
      this.horariosVisible = true;

      // Agrega esta línea para seleccionar el día de hoy
      this.seleccionarDia(this.fechaActual);

      this.generarDiasMostrados(); // Genera los días del carrusel (hoy, mañana, etc.)
    }

    // Función para obtener toda la información del especialista
    this.getEspecialista();
  }

  // Función para cargar horarios a mostrar
  private async cargarHorarios(): Promise<void> {
    this.cargando = true;

    if (!this.diaSeleccionado) {
      this.cargando = false;
      return;
    }

    const fechaInicial = this.diaSeleccionado
      .toISOString()
      .split("T")[0]
      .toString(); // YYYY-MM-DD
    const fechaFinal = this.diaSeleccionado
      .toISOString()
      .split("T")[0]
      .toString(); // YYYY-MM-DD

    try {
      const response = await firstValueFrom(
        this.__paisService.getTimeEspecialista(this.idEspecialista, fechaInicial, fechaFinal)
      );

      if (
        response["status"] === "success" &&
        response["message"].length > 0
      ) {
        this.horarios = response["message"][0].horas_disponibles || [];

        // Filtrar horarios si es hoy
        const hoy = new Date();
        const esDiaDeHoy =
          this.diaSeleccionado.toDateString() === hoy.toDateString();

        if (esDiaDeHoy) {
          const horaMinima = new Date(hoy.getTime() + 5 * 60 * 60 * 1000); // +5 horas
          const horaLimiteStr =
            horaMinima.getHours().toString().padStart(2, "0") +
            ":" +
            horaMinima.getMinutes().toString().padStart(2, "0");

          this.horarios = this.horarios.filter((horario) => {
            return horario.hora >= horaLimiteStr;
          });
        }
      } else {
        this.horarios = [];
      }
    } catch (error) {
      console.error("Error en la API:", error);
      this.horarios = [];
    }
    this.cargando = false;
  }
  // Función lanzada cuando se ha seleccionado un día de la barra de dias
  seleccionarDia(dia: Date) {
    this.diaSeleccionado = dia;
    this.cargarHorarios();
  }

  get tituloHorarios(): string {
    if (!this.diaSeleccionado) return "Horarios disponibles";

    const opciones: Intl.DateTimeFormatOptions = {
      day: "numeric",
      month: "long",
    };

    return `Horarios disponibles ${this.diaSeleccionado.toLocaleDateString(
      "es-ES",
      opciones,
    )}`;
  }

  // FUNCIONES DE FECHA Y HORARIOS

  generarDiasMostrados() {
    this.diasMostrados = [];
    let diasAgregados = 0;
    let contador = 0;

    while (diasAgregados < 3) {
      const fecha = new Date(this.fechaActual);
      fecha.setDate(this.fechaActual.getDate() + contador);

      if (fecha.getDay() !== 0) {
        // 0 = Domingo
        this.diasMostrados.push(fecha);
        diasAgregados++;
      }
      contador++;
    }
  }

  // Función lanzada para mostrar los horarios adelante y atrás
  navegarDia(direccion: number) {
    this.fechaActual.setDate(this.fechaActual.getDate() + direccion);
    this.generarDiasMostrados();
  }

  formatearFecha(fecha: Date, indice: number): string {
    const hoy = new Date();
    const opciones: Intl.DateTimeFormatOptions = {
      weekday: "short",
      day: "2-digit",
      month: "short",
    };

    if (indice === 0 && fecha.toDateString() === hoy.toDateString()) {
      return "Hoy";
    }

    return fecha
      .toLocaleDateString("es-ES", opciones)
      .replace(/^\w/, (c) => c.toUpperCase());
  }

  formatearHora(hora: string): string {
    const [horas, minutos] = hora.split(":");
    const horaNum = parseInt(horas);
    const periodo = horaNum >= 12 ? "PM" : "AM";
    const horaFormateada =
      horaNum > 12 ? horaNum - 12 : horaNum === 0 ? 12 : horaNum;
    return `${horaFormateada}:${minutos} ${periodo}`;
  }

  get puedeRetroceder(): boolean {
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    const fechaActualSinHora = new Date(this.fechaActual);
    fechaActualSinHora.setHours(0, 0, 0, 0);
    return fechaActualSinHora > hoy;
  }
}
